import { Helmet } from "react-helmet-async";

const SEO = () => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Website",
          "name": "The Lord Nation's Foundation",
          "url": "https://thelordnationsfoundation.com",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "About Us",
                "item": "https://thelordnationsfoundation.com/about-us"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Our Work",
                "item": "https://thelordnationsfoundation.com/our-work"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Partner With Us",
                "item": "https://thelordnationsfoundation.com/partner-with-us"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Contact Us",
                "item": "https://thelordnationsfoundation.com/contact-us"
              }
            ]
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
